import './playground.css'
import { useContext } from 'react'
import { ThemeContext } from '../context';

import Todo from './todoContainer/Todo';

export default function Playground() {
  const theme = useContext(ThemeContext)
  return (
    <div className={`palyground-${theme.currentTheme}`}>
      <Todo />
    </div>
  )
}
